/**
 * Enumeration of supported AI providers.
 */
export enum Provider {
  Anthropic = 'anthropic',
  Google = 'google',
  Groq = 'groq',
  OpenAI = 'openai'
}

/**
 * Represents either a built-in provider enum value or a custom provider key string.
 */
export type ProviderKey = Provider | string

export type ProviderCapability = 'llm' | 'audio'

/**
 * Configuration for an AI service provider.
 */
export interface ProviderConfig {
  providerKey: ProviderKey // providerKey will be unique. for example, we can't have 2 OpenAI providers.
  url?: string // optional, only specify if provider is not a built-in provider or the base url is different.
  apiKey?: string // optional, all built-in providers need api keys, but custom providers don't always need them.
  capabilities?: ProviderCapability[] // optional; when omitted backend defaults to ['llm'] (normalized from legacy)
}

// Request for POST /v1/core/delete/provider
export interface DeleteProviderRequest {
  providerKey: ProviderKey
}
